import { actionTypesOperations } from '../../constans/operation';

export const deleteLeaderOrganizationChart_IS = {
	data: null,
	error: null,
	loading: false,
	isLoadData: false,
};
export const deleteLeaderOrganizationChartRed = (state, actions) => {
	switch (actions.type) {
		case actionTypesOperations.DELETE_LEADER_ORGANIZATION_CHART.BASE:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
				isLoadData: false,
			};
		case actionTypesOperations.DELETE_LEADER_ORGANIZATION_CHART.ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
				data: null,
				isLoadData: false,
			};
		case actionTypesOperations.DELETE_LEADER_ORGANIZATION_CHART.SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				data: actions.payload,
				isLoadData: true,
			};
		default:
			return state;
	}
};
